/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import fetchHelper from "../../services/fetchHelper";
import { LayoutContext } from "../../components/layout";
import { PatientsContext } from ".";

import savingspinner from "../../assets/esign-ui-icons/saving-ico-white.svg";

const SubLocations = () => {
  const { patient } = useContext(PatientsContext);
  const { user } = useContext(LayoutContext);
  const { addToast } = useToasts();
  const [isSaving, setIsSaving] = useState(false);
  const [patientSubLocation, setPatientSubLocation] = useState(patient.subLocation);
  const { i } = useParams();

  const save = async (data) => {
    try {
      setIsSaving(true);
      await fetchHelper.put(`/patientmanagement/rest/patients/${i}/sublocation`, data);
      patient.subLocation = data;
      setPatientSubLocation(data);
    } catch (err) {
      console.error(err);
      err.errors.forEach((err) => {
        addToast(err.msg, {
          appearance: "error",
          autoDismiss: false,
        });
      });
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <div className="tabContent location">
      <div className="content">
        <div className="grpHdrPg">
          <h3>
            Patient Profile: <span>John Smith</span>
          </h3>
        </div>
        <div className="grpHdr">
          <h3>Sub-locations</h3>
        </div>
        <div className="row rowStretch location-row">
          <div className="col col-s-100 col33">
            <select value={patientSubLocation} onChange={(e) => save(e.target.value)}>
              <option value="">Select Sub-location ...</option>
              {user?.locations[0]?.subLocations &&
                JSON.parse(user?.locations[0]?.subLocations).map((subLocation, index) => (
                  <option value={subLocation} key={index}>
                    {subLocation}
                  </option>
                ))}
            </select>
            {isSaving && (
              <img
                src={savingspinner}
                style={{ marginLeft: 5, width: 15, backgroundColor: "lightgray" }}
              ></img>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubLocations;
